import { Injectable } from '@angular/core';
import { Horario } from '@tivic-team/manager-ts/dist/mob/entities/horario/horario.entity';
import { TabelaHorarioDTO } from 'app/model/dtos/mob/tabela-horario.dto';
import { HttpDelete, HttpFilter, HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';
import { environmentv3 } from 'src/environments/environmentv3';
import { LoteHorariosDTO } from '../../model/dtos/mob/loteHorariosDTO';
import { ApiController } from '../api-controller.interface';
import { Equal } from 'sol-request-angular/dist/comunicacao/filter/Equal';
import { HorarioTableDTO } from 'app/model/dtos/mob/horario-table.dto';

@Injectable()
export class HorarioController implements ApiController<Horario>{

	constructor() { }
	
	find(filters?: IFilter): Promise<Horario[]> {
		const request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/horario',
                    environment: environmentv3,
                    filter: filters
                })
            }),
            new HttpResponse(new Array<Horario>())
        );
        return request.call();
	}

	get(...args: number[]): Promise<Horario> {
		throw new Error('Method not implemented.');
	}

	create(entity: Horario): Promise<Horario> {
		let request = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/horario',
                    environment: environmentv3
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new Horario()
            )
        );
        return request.call();
	}
	
	update(entity: Horario): Promise<Horario> {
		let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/horario/:cdHorario',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdHorario: entity.cdHorario
                    })
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new Horario()
            )
        );
        return request.call();
	}
	
	delete(cdHorario: number, cdTabelaHorario: number, cdLinha: number, cdRota: number, cdTrecho: number): Promise<Horario> {
		let request = new Quark(
            new HttpDelete({
                url: new Url({
                    id: 'mob/horario/:cdHorario/:cdTabelaHorario/:cdLinha/:cdRota/:cdTrecho',
                    environment: environmentv3,
                    pathParams: new JSONData({cdHorario, cdTabelaHorario, cdLinha, cdRota, cdTrecho})
                }),
            }),
            new HttpResponse(
                new Horario()
            )
        );
        return request.call();
	}

	async getHorarios(cdLinha: number, cdTabelaHorario: number): Promise<HorarioTableDTO[]> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/horario/horarios',
					environment: environmentv3,
					filter: new HttpFilter([
						new Equal('cdTabelaHorario', cdTabelaHorario),
						new Equal('cdLinha', cdLinha)
						//new Equal('', cdTabelaHorario)
					])
				}),
			}),
			new HttpResponse(
				new Array<HorarioTableDTO>()
			)
		);
		return await quark.call();
	}

	async getHorariosRota(cdLinha: number, cdTabelaHorario: number, cdRota: number): Promise<any> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/horarios/:cdLinha/:cdTabelaHorario/:cdRota/horariorota',
					environment: environment,
					pathParams: new JSONData({ 
						cdTabelaHorario,
						cdLinha,
						cdRota
					})
				}),
			}),
			new HttpResponse(
				new TabelaHorarioDTO()
			)
		);
		return await quark.call();
	}

	async saveLote(loteHorariosDTO:LoteHorariosDTO):Promise<LoteHorariosDTO>{
        let quark = new Quark(
			new HttpPost({
				url: new Url({
					id: 'mob/horarios/loteHorarios',
					environment: environment
				}),
				data: new JSONData(loteHorariosDTO)
			}),
			new HttpResponse(
				new Array<LoteHorariosDTO>()
			)
        );
        return await quark.call();
	}

	async saveGrupoHorarios(horarios:Array<Horario>):Promise<Array<Horario>>{
        let quark = new Quark(
			new HttpPost({
				url: new Url({
					id: 'mob/horarios/grupoHorarios',
					environment: environment
				}),
				data: new JSONData(horarios)
			}),
			new HttpResponse(
				new Array<Horario>()
			)
        );
        return await quark.call();
	}
}
